import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepMedicalExpenses = (state) => state.get('stepMedicalExpenses');

const makeSelectStepMedicalExpenses = () => createSelector(
  selectStepMedicalExpenses,
  (stepMedicalExpensesState) => ({
    relationshipToYou: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'relationshipToYou']),
      ''
    ),
    nationalIdOrVisa: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'nationalIdOrVisa']),
      ''
    ),
    id: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'id']),
      ''
    ),
    purposeOfTrip: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'purposeOfTrip']),
      ''
    ),
    didYouContactAssistanceCompany: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'didYouContactAssistanceCompany']),
      ''
    ),
    ifOtherPleaseDescribe: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifOtherPleaseDescribe']),
      ''
    ),
    disYouContactAssistanceCompany: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'disYouContactAssistanceCompany']),
      ''
    ),
    assistanceCaseReferenceNumberFileNumber: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'assistanceCaseReferenceNumberFileNumber']),
      ''
    ),
    didYouHaveOtherMedicalInsurance: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'didYouHaveOtherMedicalInsurance']),
      ''
    ),
    insuranceCarriersName: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'insuranceCarriersName']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'policyId']),
      ''
    ),
    areYouACitizenOfTheEuropeanUnion: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'areYouACitizenOfTheEuropeanUnion']),
      ''
    ),
    forEUCitizens: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'forEUCitizens']),
      ''
    ),
    ifYesWasTheEHIC: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifYesWasTheEHIC']),
      ''
    ),
    ifNoPleaseExplain: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifNoPleaseExplain']),
      ''
    ),
    accidentStartDate: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'accidentStartDate']),
      ''
    ),
    accidentFirstTreatment: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'accidentFirstTreatment']),
      ''
    ),
    nameOfPhysicianFacilityFirstContacted: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'nameOfPhysicianFacilityFirstContacted']),
      ''
    ),
    addressForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'addressForHospital']),
      ''
    ),
    cityOrTownForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'cityOrTownForHospital']),
      ''
    ),
    countryForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'countryForHospital']),
      ''
    ),
    emailForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'emailForHospital']),
      ''
    ),
    phoneNumberForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'phoneNumberForHospital']),
      ''
    ),
    postalCodeForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'postalCodeForHospital']),
      ''
    ),
    isTheClaimTheResultOfAniLLness: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'isTheClaimTheResultOfAniLLness']),
      ''
    ),
    alternativeTreatment: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'alternativeTreatment']),
      ''
    ),
    accidentStartDateForIllness: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'accidentStartDateForIllness']),
      ''
    ),
    symptoms: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'symptoms']),
      ''
    ),
    detailsForIllness: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'detailsForIllness']),
      ''
    ),
    isTheClaimTheResultOfAccidentOrInjury: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'isTheClaimTheResultOfAccidentOrInjury']),
      ''
    ),
    ifOtherPleaseDescribeForHospital: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifOtherPleaseDescribeForHospital']),
      ''
    ),
    wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity']),
      ''
    ),
    place: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'place']),
      ''
    ),
    accidentDate: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'accidentDate']),
      ''
    ),
    accidentTime: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'accidentTime']),
      ''
    ),
    detailsForAccident: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'detailsForAccident']),
      ''
    ),
    wasTheAccidentOrInjuryTheResultOfPlayingASportODueToAHazardousActivity: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'wasTheAccidentOrInjuryTheResultOfPlayingASportODueToAHazardousActivity']),
      ''
    ),
    nameOfPhysicianFacilityFirstContactedForPhysician: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'nameOfPhysicianFacilityFirstContactedForPhysician']),
      ''
    ),
    addressForPhysician: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'addressForPhysician']),
      ''
    ),
    cityOrTownForPhysician: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'cityOrTownForPhysician']),
      ''
    ),
    countryForPhysician: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'countryForPhysician']),
      ''
    ),
    postalCodeForPhysician: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'postalCodeForPhysician']),
      ''
    ),
    phoneNumberForPhysician: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'phoneNumberForPhysician']),
      ''
    ),
    facilityName: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'facilityName']),
      ''
    ),
    addressForProvide: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'addressForProvide']),
      ''
    ),
    cityOrTownForProvide: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'cityOrTownForProvide']),
      ''
    ),
    countryForProvide: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'countryForProvide']),
      ''
    ),
    postalCodeForProvide: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'postalCodeForProvide']),
      ''
    ),
    phoneNumberForProvide: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'phoneNumberForProvide']),
      ''
    ),
    admitDate: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'admitDate']),
      ''
    ),
    timeOfAdmission: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'timeOfAdmission']),
      ''
    ),
    dischargeDate: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'dischargeDate']),
      ''
    ),
    timeOfDischarge: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'timeOfDischarge']),
      ''
    ),
    expensesClaimed: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'expensesClaimed']),
      ''
    ),
    currencyForProvide: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'currencyForProvide']),
      ''
    ),
    didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness']),
      ''
    ),
    wereYouTravelingToReceiveMedicalTreatment: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'wereYouTravelingToReceiveMedicalTreatment']),
      ''
    ),
    ifYesWhenDidYouLearnOfTheAlternativeTreatment: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifYesWhenDidYouLearnOfTheAlternativeTreatment']),
      ''
    ),
    whoRecommendedTheTreatment: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'whoRecommendedTheTreatment']),
      ''
    ),
    areYouPregnant: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'areYouPregnant']),
      ''
    ),
    ifYesNumberOfWeeks: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifYesNumberOfWeeks']),
      ''
    ),
    changeTo: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'changeTo']),
      ''
    ),
    ifYesNameOfPhysicianCurrentlyTreatingThis: mapWithDefault(
      stepMedicalExpensesState,
      () => stepMedicalExpensesState.getIn(['form', 'ifYesNameOfPhysicianCurrentlyTreatingThis']),
      ''
    ),
    prescriptionMedicinesNotInjury: mapWithDefault(stepMedicalExpensesState, () => stepMedicalExpensesState.getIn(['form', 'prescriptionMedicinesNotInjury']) && stepMedicalExpensesState.getIn(['form', 'prescriptionMedicinesNotInjury']).toJS(), ''),
    prescriptionMedicinesForInjury: mapWithDefault(stepMedicalExpensesState, () => stepMedicalExpensesState.getIn(['form', 'prescriptionMedicinesForInjury']) && stepMedicalExpensesState.getIn(['form', 'prescriptionMedicinesForInjury']).toJS(), ''),
  })
);

const makeSelectStepMedicalExpensesErrors = () =>
  createSelector(selectStepMedicalExpenses, (state) => state.get('errors'));

export {
  makeSelectStepMedicalExpenses,
  makeSelectStepMedicalExpensesErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepMedicalExpenses/selectors.js